import { render, staticRenderFns } from "./ValeAssetManagement.vue?vue&type=template&id=bc2a58bc&scoped=true&"
import script from "./ValeAssetManagement.vue?vue&type=script&lang=js&"
export * from "./ValeAssetManagement.vue?vue&type=script&lang=js&"
import style0 from "./ValeAssetManagement.vue?vue&type=style&index=0&id=bc2a58bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2a58bc",
  null
  
)

export default component.exports